// Per page-load flag: greeting shows once per full load (login, refresh, new session), not on in-app navigation.
let greeted = false;
export const shouldGreet = () => !greeted;
export const markGreeted = () => { greeted = true; };
export const resetGreeting = () => { greeted = false; };
